@if (data().options.enabled) {
  <ui-product-slider-skeleton></ui-product-slider-skeleton>
} @else {
  <div [class]="cardViewClass()">
    @for (i of skeletonArray; track $index) {
      <ui-product-card-skeleton></ui-product-card-skeleton>
    }
  </div>
}
